import * as React from 'react';
import { VendorViewModel } from '@models/Vendor';
import { Errors, Control, Form } from 'react-redux-form';
import { getDefaultErrorMessages } from '@common/validators';
import { hasNumber } from '@common/validators';
import FormNames from '@constants/FormNames.enum';

export interface VendorDefaultRatingsComponentProperties {
  readonly currentStep: number;
  readonly vendor?: VendorViewModel;
}
export class VendorDefaultRatingsComponent extends React.Component<VendorDefaultRatingsComponentProperties> {
  render() {
    return (
      <div>
        <Form model={FormNames.VendorDefaultRatings} hideNativeErrors={true}>
          <div className="row middle-xs">
            <div className="form-control col-md-4">
              <label htmlFor=".invoicePricing">Invoice Pricing</label>
              <Control.text
                model=".invoicePricing"
                maxLength={1}
                validators={{ hasNumber, inRange: (val: number) => 0 <= val && val <= 5 }}
              />
              <Errors
                className="error error-pad"
                model=".invoicePricing"
                show={{ touched: true, focus: false }}
                messages={getDefaultErrorMessages({ inRange: 'Rating must be between 0 and 5.' })}
              />
            </div>
            <div className="form-control col-md-4">
              <label htmlFor=".vendorRelations">Vendor Relations Rating</label>
              <Control.text
                model=".vendorRelations"
                maxLength={1}
                validators={{ hasNumber, inRange: (val: number) => 0 <= val && val <= 5 }}
              />
              <Errors
                className="error error-pad"
                model=".vendorRelations"
                show={{ touched: true, focus: false }}
                messages={getDefaultErrorMessages({ inRange: 'Rating must be between 0 and 5.' })}
              />
            </div>
            <div className="form-control col-md-4">
              <label htmlFor=".customerRelations">Customer Relations</label>
              <Control.text
                model=".customerRelations"
                maxLength={1}
                validators={{ hasNumber, inRange: (val: number) => 0 <= val && val <= 5 }}
              />
              <Errors
                className="error error-pad"
                model=".customerRelations"
                show={{ touched: true, focus: false }}
                messages={getDefaultErrorMessages({ inRange: 'Rating must be between 0 and 5.' })}
              />
            </div>
          </div>
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/flows/vendor-edit/vendor-detault-ratings.component.tsx